import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faRedo,
  faEdit,
  faCreditCard,
  faCheck,
} from "@fortawesome/free-solid-svg-icons";
import "./updates.css";

const features = [
  {
    icon: faRedo,
    title: "Recurring Payments & Subscriptions",
    description:
      "Set up automated billing for regular clients and training packages, with a first charge date that works for your business.",
  },
  {
    icon: faEdit,
    title: "Invoice Editing",
    description:
      "Adjust unpaid invoices, correct details, and add, remove, or update line items without canceling and recreating the invoice.",
  },
  {
    icon: faCreditCard,
    title: "Client Card Management",
    description:
      "Securely add and manage saved client payment methods for future checkouts and recurring billing. You will have the option to let your clients manage their cards themselves.",
  },
];

export const Updates = () => (
  <main className="updateContainer updates-page">
    <header className="updates-heading">
      <h1>Updates</h1>
      <p>The latest from Equine Office</p>
    </header>
    <article aria-labelledby="october-release-title">
      <header className="updates-release-heading">
        <time dateTime="2026-10">October 2026</time>
        <h2 id="october-release-title">Introducing Equine Office 3.0</h2>
        <p>
          Three highly requested features are here to make everyday billing
          easier. Explore what's new for your business.
        </p>
      </header>
      <section className="updates-features" aria-label="New features">
        {features.map((feature) => (
          <div className="updates-feature" key={feature.title}>
            <FontAwesomeIcon icon={feature.icon} aria-hidden="true" />
            <div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          </div>
        ))}
      </section>
      <p>
        <strong>This is just the beginning.</strong> We have a pipeline of major
        new features and improvements that will be rolling out over the coming
        months.
      </p>

      <p>
        Would you like a personal walkthrough of these new features?{" "}
        <a
          href="https://calendly.com/equineoffice/training-refresher"
          target="_blank"
          rel="noopener noreferrer"
        >
          Book a Training Session
        </a>
        .
      </p>
      <section
        className="updates-pricing"
        aria-labelledby="updates-pricing-title"
      >
        <div className="updates-section-label">What's next</div>
        <h2 id="updates-pricing-title">Introducing Tiered Pricing</h2>
        <p>
          To support these upgrades and keep improving Equine Office, we'll be
          introducing new tiered pricing plans soon.
        </p>
        <h3>What this means for you</h3>
        <ul className="updates-benefits">
          <li>
            <FontAwesomeIcon icon={faCheck} aria-hidden="true" />
            <div>
              <strong>Try the new features now.</strong> All current users have
              access to these three new features during the preview.
            </div>
          </li>
          <li>
            <FontAwesomeIcon icon={faCheck} aria-hidden="true" />
            <div>
              <strong>Upgrade to keep them.</strong> Choose one of the new
              premium tiers when they launch to keep the new features in your
              workflow.
            </div>
          </li>
          <li>
            <FontAwesomeIcon icon={faCheck} aria-hidden="true" />
            <div>
              <strong>Keep your current price.</strong> If you don't need the
              new features, you can stay on your existing plan. Your current
              price and existing features will remain the same.
            </div>
          </li>
        </ul>
        <p className="updates-pricing-note">
          Watch for an email with the full plan details, pricing, and launch
          dates. We'd love to hear your feedback as you try the new features.
        </p>
      </section>
    </article>
    <aside className="updates-refresh" aria-labelledby="updates-refresh-title">
      <h3 id="updates-refresh-title">Not seeing the latest update?</h3>
      <p>
        Updates normally appear automatically. Refresh your browser if something
        doesn't look right. On mobile devices, especially iPhones, try logging
        out and back in if refreshing doesn't help.
      </p>
    </aside>
  </main>
);
